import JWTService from 'app/services/jwtService';
import * as FullStory from '@fullstory/browser';
import { setUserData } from './user.actions';
import { datadogRum } from '@datadog/browser-rum';
import { getAccessList } from '../../../store/actions';
import { addPageTracking } from '../../../../utils';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

/**
 * Returns true if Datadog session recording should be started for this user.
 * Recording is active if datadog_session_recording_until is set and is in the future.
 */
function shouldStartRecording(userData) {
    const until = userData?.datadog_session_recording_until;
    if (!until) return false;
    return new Date(until) > new Date();
}

export async function onCognitoLogin() {
    return async (dispatch) => {
        try {
            const user = await JWTService.signInWithCognitoSession();

            datadogRum.setUser({
                id: user.data.id,
                email: user.data.email,
                name: user.data.name,
                region: user.data.region,
                role: user.role,
            });

            // Start session recording only if a super user has enabled it and it has not expired
            if (shouldStartRecording(user.data)) {
                datadogRum.startSessionReplayRecording();
            }

            addPageTracking('login');

            // Set Fullstory info
            FullStory.identify(user.data.id, {
                displayName: user.data.name,
                email: user.data.email,
                Region: user.data.region,
                'Account Type': user.role.charAt(0).toUpperCase() + user.role.slice(1),
            });

            dispatch(setUserData(user));

            dispatch(getAccessList());

            return dispatch({ type: LOGIN_SUCCESS, payload: user });
        } catch (error) {
            return dispatch({ type: LOGIN_ERROR, payload: error });
        }
    };
}

export async function onCognitoUnlock() {
    return async (dispatch) => {
        try {
            const user = await JWTService.signInWithCognitoSession();
            datadogRum.setUser({
                id: user.data.id,
                email: user.data.email,
                name: user.data.name,
                region: user.data.region,
                role: user.role,
            });

            // Start session recording only if a super user has enabled it and it has not expired
            if (shouldStartRecording(user.data)) {
                datadogRum.startSessionReplayRecording();
            }

            addPageTracking('unlock');

            dispatch({ type: LOGIN_SUCCESS, payload: user });
        } catch (error) {
            dispatch({ type: LOGIN_ERROR, payload: error });
        }
    };
}
